export default "__VITE_ASSET__7G8ljveP__"